<div>
    <app-header-and-menu></app-header-and-menu>
    <mat-sidenav-container class="sidenav-container" autosize>
        <div class="main_content">
            <app-left-menu></app-left-menu>
        </div>
    </mat-sidenav-container>
</div>
